import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { AddStudentToGroupPayload } from "../../payload/AddStudentToGroup/AddStudentToGroupPayload";

const addStudentToGroupFetch = (state: GroupsState, action: PayloadAction<AddStudentToGroupPayload>) => {
    state.isLoading = true;
}

export default addStudentToGroupFetch;